import React, { createContext } from 'react';

import { Institute } from '@nw/shared/config';

interface InstitutesContextTypes {
  institutes: React.MutableRefObject<Array<Institute>>;
  selectedInstitute: React.MutableRefObject<Institute>;
  updateInstitutes: (states: Array<Institute>) => void;
  updateSelectedInstitute: (state: Institute) => void;
}

const InstitutesContext = createContext<InstitutesContextTypes | null>({
  institutes: { current: [] },
  selectedInstitute: { current: {} as Institute },
  updateInstitutes: () => {},
  updateSelectedInstitute: () => {}
});

export const useInstitute = () => {
  const context = React.useContext(InstitutesContext);

  if (!context)
    throw new Error('Expected to be wrapped in a InstitutesProvider');

  return context;
};

export const InstitutesProvider = ({
  children
}: {
  children: React.ReactChild;
}) => {
  const institutes = React.useRef<Array<Institute>>([]);
  const institute = React.useRef<Institute>({} as Institute);

  const updateInstitutes = (latestColleges: Array<Institute>) => {
    institutes.current = latestColleges;
  };

  const updateSelectedInstitute = (selectedState: Institute) => {
    institute.current = selectedState;
  };

  return (
    <InstitutesContext.Provider
      value={{
        institutes,
        selectedInstitute: institute,
        updateInstitutes,
        updateSelectedInstitute
      }}
    >
      {children}
    </InstitutesContext.Provider>
  );
};
